/** Parse and sanitize emails from Google SSO / Cognito account-link errors. */

export const ACCOUNT_LINK_REQUIRED_ERROR = 'LUMINA_ACCOUNT_LINK_REQUIRED';

/**
 * First email-shaped token. Stops before Cognito's sentence-terminating
 * period (``user@host.com.`` → ``user@host.com``).
 */
const EMAIL_TOKEN =
  /[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}/;

export function normalizeAuthEmail(value: string): string {
  const trimmed = value.trim().replace(/^['"]+|['"]+$/g, '');
  if (!trimmed) return '';
  const match = trimmed.match(EMAIL_TOKEN);
  if (!match) return '';
  return match[0].toLowerCase();
}

function decodeErrorDescription(errorDescription: string): string {
  const plusDecoded = errorDescription.replace(/\+/g, ' ');
  try {
    return decodeURIComponent(plusDecoded);
  } catch {
    return plusDecoded;
  }
}

/**
 * Cognito Hosted UI wraps PreSignUp Lambda exceptions as:
 * ``PreSignUp failed with error LUMINA_ACCOUNT_LINK_REQUIRED:user@host.com.``
 * The trailing period is Cognito's, not part of the email.
 *
 * @returns ``null`` when this is not a link-required error;
 *          a (possibly empty) sanitized email when it is.
 */
export function parseAccountLinkEmail(errorDescription: string): string | null {
  if (!errorDescription) return null;
  const decoded = decodeErrorDescription(errorDescription);
  if (!decoded.includes(ACCOUNT_LINK_REQUIRED_ERROR)) {
    return null;
  }
  const idx = decoded.indexOf(ACCOUNT_LINK_REQUIRED_ERROR);
  const after = decoded
    .slice(idx + ACCOUNT_LINK_REQUIRED_ERROR.length)
    .replace(/^[:\s]+/, '');
  return normalizeAuthEmail(after);
}
